/** @format */

import { Alert, Avatar, Box, Divider, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../app/hooks';
import DisplayFieldData from '../../../common/custom/DisplayFieldData';
import CircularLoader from '../../../common/loaders/circularLoader';
import { selectApplicant } from '../../applicant/ApplicantSlice';
import {
  ApplicantViewDto,
  LegalGuardianDetailDto,
} from '../../applicant/Models';

export default function ViewLeagalGuardians() {
  const selectApplicantData = useAppSelector(selectApplicant);
  const [data, setData] = useState<ApplicantViewDto>();

  useEffect(() => {
    if (selectApplicantData.applicantState.applicant) {
      setData(selectApplicantData.applicantState.applicant);
    }
  }, [selectApplicantData.applicantState.applicant]);

  return (
    <>
      <CircularLoader status={selectApplicantData.applicantState.status} />

      {data && data.guardians.length < 1 && (
        <>
          <Alert severity="info" variant="standard" color="info">
            There are no guardians to display
          </Alert>
        </>
      )}
      <Grid container spacing={2}>
        {data &&
          data.guardians.map(
            (guardian: LegalGuardianDetailDto, key: React.Key) => (
              <Grid item xs={6}>
                <Box sx={{ display: 'flex' }}>
                  <Avatar
                    sx={{
                      width: '80px',
                      height: '80px',
                      fontSize: '32px',
                    }}>{`${guardian.firstName.charAt(
                    0
                  )}${guardian.surname.charAt(0)}`}</Avatar>
                  <Box ml={3}>
                    <Box
                      sx={{
                        fontWeight: 600,
                      }}>{`${guardian.firstName} ${guardian.surname}`}</Box>
                    <Typography variant='body2'>
                      {guardian.identityNumber}
                    </Typography>
                    <Typography variant='body2'>
                      {guardian.contactNumber}
                    </Typography>

                    <Typography
                      variant='body2'
                      sx={{ fontStyle: 'italic', fontSize: '11px', mt: 1 }}>
                      {guardian.employed ? 'Working' : 'Not Working'}
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ mt: 2, mb: 3 }} />

                <DisplayFieldData
                  header='Name of the company'
                  value={guardian.companyName}
                />

                <DisplayFieldData
                  header='Contact Number'
                  value={guardian.companyContact}
                />
                <DisplayFieldData
                  header='Occupation'
                  value={guardian.occupation}
                />

                <Divider sx={{ mt: 2, mb: 3 }} />

                {/* <DisplayFieldData
                  header='Dependants'
                  value={guardian.houseHoldIncomeDepandants}
                /> */}
              </Grid>
            )
          )}
      </Grid>
    </>
  );
}
